import React from "react";
class PrivacyPolicyContent extends React.Component {
  render() {
    return (
      <section className="section " style={{ paddingTop: "40px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-left">
                <p>
                  At MightyWifi, we believe that anyone who uses the internet
                  should be fully aware of how their information is used, so
                  we've put together this document to explain exactly how we
                  approach handling your data.
                </p>

                <p>
                  <b>Your privacy is as important to us as it is to you.</b>{" "}
                  Giving us your personal details is an act of trust, and one
                  that we take seriously. We will never show your details to
                  anyone else, sell, rent, or otherwise disclose any of your
                  personal information, including your email address, to any
                  third party without your prior and explicit consent.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  Security
                </h3>
                <p>
                  Personal information provided on the website and online credit
                  card transactions are transmitted through a secure server. We
                  are committed to handling your personal information with high
                  standards of information security. We take appropriate
                  physical, electronic, and administrative steps to maintain the
                  security and accuracy of personally identifiable information
                  we collect, including limiting the number of people who have
                  physical access to our database servers, as well as employing
                  electronic security systems and password protections that
                  guard against unauthorized access.
                  <br />
                  <br />
                  Our website uses encryption technology, like Secure Sockets
                  Layer (SSL), to protect your personal information during data
                  transport. SSL encrypts ordering information such as your
                  name, address, and credit card number. Our Customer Care
                  center and stores also operate over a private, secure network.
                  Please note that email is not encrypted and is not considered
                  to be a secure means of transmitting credit card information.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  Privacy Policy
                </h3>
                <p>
                  To help us achieve our goal of providing the highest quality
                  products and services, we use information from our
                  interactions with you and other customers, as well as from
                  other parties. Because we respect your privacy, we have
                  implemented procedures to ensure that your personal
                  information is handled in a safe, secure, and responsible
                  manner. We have posted this privacy policy in order to explain
                  our information collection practices and the choices you have
                  about the way information is collected and used.
                  <br />
                  <br />
                  As we continue to develop the Mightywifi website and take
                  advantage of advances in technology to improve the services we
                  offer, this privacy policy likely will change. We therefore
                  encourage you to refer to this policy on an ongoing basis so
                  that you understand our current privacy policy.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  The Information We Collect
                </h3>
                <p>
                  Generally, you may browse the Mightywifi website without
                  providing any personally identifiable information. However, we
                  may ask you to provide personally identifiable information at
                  various times and places on this website. In some cases, if
                  you choose not to provide us with the requested information,
                  you may not be able to access all parts of this website or
                  participate in all of its features, pricing, and product
                  selection.
                  <br />
                  <br />
                  We may collect the following information:
                  <br />
                  <ul>
                    <li>name</li>
                    <li>contact information including email address</li>
                    <li>
                      demographic information such as postcode, preferences and
                      interests
                    </li>
                    <li>
                      other information relevant to customer surveys and/or
                      offers
                    </li>
                  </ul>
                  <br />
                  For the exhaustive list of cookies we collect see the List of
                  cookies we collect section. From your purchases and other
                  interactions with us, we obtain information concerning the
                  specific products or services you purchase or use. When you
                  visit this website, our web server automatically collects
                  anonymous information such as log data and IP addresses, and
                  may collect general information concerning your location. We
                  may use the automatically collected information for a number
                  of purposes, such as improving our site design, product
                  assortments, customer service, and special promotions.
                </p>

                <h3
                  className="font-weight-bold"
                  style={{
                    color: "#0076be",
                    fontSize: "1.3rem",
                    marginTop: "30px"
                  }}
                >
                  How We Use The Information We Collect
                </h3>
                <p>
                  We require this information to understand your needs and
                  provide you with a better service, and in particular for the
                  following reasons:
                  <br />
                  <ul>
                    <li>Internal record keeping.</li>
                    <li>
                      We may use the information to improve our products and
                      services.
                    </li>
                    <li>
                      We may periodically send promotional emails about new
                      products, special offers or other information which we
                      think you may find interesting using the email address
                      which you have provided.
                    </li>
                    <li>
                      From time to time, we may also use your information to
                      contact you for market research purposes. We may contact
                      you by email, phone, fax or mail. We may use the
                      information to customize the website according to your
                      interests.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PrivacyPolicyContent;



// WEBPACK FOOTER //
// ./src/pages/privacyPolicy/PrivacyPolicyContent.js